import React, { FormEvent, useState } from 'react';
import { MessageSquare, Send, X } from 'lucide-react';
import { useAppContext } from '../../contexts/AppContext';
import communicationService from '../../services/CommunicationService';

const FeedbackWidget: React.FC = () => {
  const { state } = useAppContext();
  const [open, setOpen] = useState(false);
  const [sending, setSending] = useState(false);
  const [status, setStatus] = useState<string | null>(null);
  const [form, setForm] = useState({
    category: 'Feedback',
    subject: '',
    message: ''
  });

  const submitFeedback = async (event: FormEvent) => {
    event.preventDefault();
    if (!form.subject.trim() || !form.message.trim()) {
      setStatus('Add a subject and message before sending.');
      return;
    }

    setSending(true);
    setStatus(null);
    try {
      await communicationService.sendFeedback({
        ...form,
        senderName: state.currentUser?.name,
        senderEmail: state.currentUser?.email,
        accountId: state.currentUser?.id,
        companyId: state.currentUser?.companyId,
        pageUrl: window.location.href
      });
      setStatus('Sent. FleetFix support can reply to your account email.');
      setForm({ category: 'Feedback', subject: '', message: '' });
    } catch (error) {
      setStatus(error instanceof Error ? error.message : 'Feedback could not be sent.');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="feedback-widget">
      {open && (
        <section className="feedback-panel" aria-label="FleetFix feedback form">
          <div className="feedback-header">
            <div>
              <strong>Send FleetFix Feedback</strong>
              <span>Ideas, bugs, questions, and inquiries go straight to the owner.</span>
            </div>
            <button type="button" aria-label="Close feedback" onClick={() => setOpen(false)}><X size={16} /></button>
          </div>
          <form onSubmit={submitFeedback} className="feedback-form">
            <label>Category
              <select value={form.category} onChange={event => setForm(current => ({ ...current, category: event.target.value }))}>
                <option>Feedback</option>
                <option>Bug report</option>
                <option>Feature request</option>
                <option>Inquiry</option>
                <option>Sales question</option>
              </select>
            </label>
            <label>Subject
              <input value={form.subject} onChange={event => setForm(current => ({ ...current, subject: event.target.value }))} placeholder="What should we improve?" />
            </label>
            <label>Message
              <textarea value={form.message} onChange={event => setForm(current => ({ ...current, message: event.target.value }))} rows={5} placeholder="Tell us what happened or what you need." />
            </label>
            {status && <p className="feedback-status">{status}</p>}
            <button className="btn-primary" type="submit" disabled={sending}>
              <Send size={15} />
              {sending ? 'Sending' : 'Send Feedback'}
            </button>
          </form>
        </section>
      )}
      <button className="feedback-launcher" type="button" onClick={() => setOpen(openState => !openState)} aria-label="Send feedback">
        <MessageSquare size={20} />
        <span>Feedback</span>
      </button>
    </div>
  );
};

export default FeedbackWidget;
